import { render } from "./DebugButtons.vue?vue&type=template&id=1f2a42fc"
import script from "./DebugButtons.vue?vue&type=script&lang=js"
export * from "./DebugButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__